export default __webpack_public_path__ + "static/media/25.90667922.wav";